<template>
  <EventHorizontalProductShowcase
    v-if="products.length || pending"
    :products="products"
    :pending="pending"
    :title="showcaseTitle"
    :gtm-item-list-id="GtmItemListId.KitsPageKits"
    :algolia-insights-label="algoliaInsightsLabel"
    data-test-id="kit-events-section"
    :loader-products-count="products.length || 6"
  />
</template>

<script setup lang="ts">
import { useFetchSimilarKits } from '~/composables/product'
import { GtmItemListId } from '~/composables/useKftGtm/types'

const {
  category,
  title = undefined,
  algoliaInsightsLabel = 'Kits - Kits Page',
} = defineProps<{
  category: string
  title?: string
  algoliaInsightsLabel?: string
}>()

const { t } = useI18n()

const showcaseTitle = computed(
  () => title ?? t('product.boxSimilarLabelOnEventPage')
)

const ITEMS_PER_PAGE = 8

const { data: boxesEvents, pending } = await useFetchSimilarKits(
  category,
  ITEMS_PER_PAGE
)

const products = computed(() => {
  if (!boxesEvents.value?.data?.length) return []
  return transformToAlgoliaEvent({ data: boxesEvents.value.data })
})
</script>
